import { IconProps } from "../../../types/style";

const ClockFillSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          fill={color}
        />
        <path
          d="M15.7099 15.9298C15.5799 15.9298 15.4499 15.8998 15.3299 15.8198L12.2299 13.9698C11.4599 13.5098 10.8899 12.4998 10.8899 11.6098V7.50977C10.8899 7.09977 11.2299 6.75977 11.6399 6.75977C12.0499 6.75977 12.3899 7.09977 12.3899 7.50977V11.6098C12.3899 11.9698 12.6899 12.4998 12.9999 12.6798L16.0999 14.5298C16.4599 14.7398 16.5699 15.1998 16.3599 15.5598C16.2099 15.7998 15.9599 15.9298 15.7099 15.9298Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ClockFillSVG;
